import { IdType } from '@store/slices/notification/notification';
import { getTabId } from '@utils/storage';
import { logger } from '@utils/logger';

const NOTIFICATION_CHANNEL = 'notification_channel';

// Only ids travel over the channel — notification payloads carry PHI.
export type NotificationSyncMessage =
  | { type: 'read'; id: IdType; userId: IdType }
  | { type: 'delete_all'; userId: IdType };

export const postNotificationSync = (message: NotificationSyncMessage) => {
  try {
    const channel = new BroadcastChannel(NOTIFICATION_CHANNEL);
    channel.postMessage({ ...message, from: getTabId() });
    channel.close();
  } catch {
    logger.warn('BroadcastChannel not supported');
  }
};

export const subscribeNotificationSync = (
  cb: (message: NotificationSyncMessage) => void
) => {
  let channel: BroadcastChannel;
  try {
    channel = new BroadcastChannel(NOTIFICATION_CHANNEL);
  } catch {
    logger.warn('BroadcastChannel not supported');
    return () => {};
  }

  channel.onmessage = (event: MessageEvent) => {
    const { from, ...message } = event.data || {};
    if (!message.type || from === getTabId()) return;
    cb(message as NotificationSyncMessage);
  };

  return () => channel.close();
};
